import React from 'react';
import { Box, ButtonBase, Tooltip } from '@mui/material';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import { useNavigate } from 'react-router';
import { withLanguage } from '../common/Texts';
import { topbarTokens as t } from './tokens';

export default function CreditsBadge({ credits, language, onNavigate }) {
    const tr = withLanguage(language);
    const navigate = useNavigate();
    const isEmpty = credits === 0;
    const label = tr('credits');
    const display = Number.isFinite(credits) ? Math.max(0, Math.trunc(credits)) : 0;

    const handleClick = () => {
        // El drawer mobile necesita cerrarse antes de navegar.
        if (onNavigate) onNavigate();
        navigate('/credits');
    };

    const sx = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1.25,
        py: 0.625,
        borderRadius: `${t.radius.md}px`,
        border: `1px solid ${isEmpty ? t.color.danger : t.color.border}`,
        backgroundColor: t.color.surface,
        color: isEmpty ? t.color.danger : t.color.fg,
        fontFamily: t.font.sans,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: 1,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: t.color.bgSub,
            borderColor: isEmpty ? t.color.danger : t.color.primaryBorder,
        },
        '&:focus-visible': {
            outline: `2px solid ${t.color.primary}`,
            outlineOffset: 2,
        },
    };

    return (
        <Tooltip title={tr('credits_history')}>
            <ButtonBase
                onClick={handleClick}
                aria-label={`${display} ${label} — ${tr('credits_history')}`}
                sx={sx}
            >
                <AccountBalanceWalletOutlinedIcon sx={{ fontSize: 16 }}/>
                <Box component="span">{display}</Box>
                <Box component="span" sx={{
                    color: t.color.fgSubtle,
                    fontWeight: 500,
                    display: { xs: 'none', sm: 'inline' },
                }}>
                    {label.toLowerCase()}
                </Box>
            </ButtonBase>
        </Tooltip>
    );
}
